import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { displayTagOfThumbAttach } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import { getLinkDownloadFileFromS3 } from '../common/FileUploaded';
import TooltipThumb from '../common/TooltipThumb';
import { PropTypes } from 'prop-types';
import './AttachFileChatPost.css';

function OtherAttachFile({ attachData, detailTicket, setOpenFileOption, setOpenOption }) {
    if (!attachData?.fileInfo) return null;

    const fileData = {
        fileUrl: attachData.fileInfo.fileUrl,
        id: attachData.originId,
        content: attachData.fileInfo.fileName,
        type: Constant.S3_FILE_TYPE.TICKET_FILE
    };

    const downloadLink = getLinkDownloadFileFromS3(
        fileData,
        detailTicket,
        null,
        null,
        true // isLinkDownload = true for download link
    );
    const displayTextInFile = displayTagOfThumbAttach(
        detailTicket || {},
        attachData?.fileInfo?.fileName
    ) || { colorCode: '', name: '' };

    return (
        <div className="display-thumb">
            <div className="class-relative cursor-default listmap-item image-attach-file-container">
                <TooltipThumb
                    value={`${attachData.fileInfo.fileName}(${Utils.formatBytes(attachData.fileInfo.fileSize)})`}
                    className="titleDisplay"
                >
                    <a
                        href={downloadLink || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className="image-attach-file-thumbnail"
                            src="/assets/image/others_file.png"
                            alt=""
                        />
                    </a>
                </TooltipThumb>
                <div
                    className="image-attach-file-more"
                    onClick={e => {
                        setOpenFileOption?.(attachData);
                        setOpenOption?.(e.currentTarget);
                    }}
                >
                    <img src="/assets/image/icon-more-panel.svg" alt="" />
                </div>
                <span
                    className="attach-file-thumbnail-label"
                    style={{
                        backgroundColor: displayTextInFile?.colorCode
                    }}
                >
                    {displayTextInFile?.name}
                </span>
            </div>
        </div>
    );
}

OtherAttachFile.propTypes = {
    attachData: PropTypes.any,
    detailTicket: PropTypes.any,
    setOpenFileOption: PropTypes.func,
    setOpenOption: PropTypes.func
};

export default OtherAttachFile;
